import { createSlice } from '@reduxjs/toolkit';

const otpSlice = createSlice({
  name: 'otp',
  initialState: {
    otp: null,
    phone: null,
    device_id: null,
    error: false,
    poperror: false,
    success: false,
    isChecked: true,
    isErrorModalOpen: false
  },
  reducers: {
    setOtp: (state, action) => {
      state.otp = action.payload;
      state.error = false;
    },
    setPhone: (state, action) => {
      state.phone = action.payload;
    },
    setDeviceId: (state, action) => {
      state.device_id = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setPopError: (state, action) => {
      state.poperror = action.payload;
    },
    setIsChecked: (state, action) => {
      state.isChecked = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    openErrorModal: (state) => {
      state.isErrorModalOpen = true;
    },
    closeErrorModal: (state) => {
      state.isErrorModalOpen = false;
      state.error = ''
      state.poperror = ''
    }
  },
});

export const { setOtp, setPhone, setDeviceId, setError, setPopError, setIsChecked, setSuccess, openErrorModal, closeErrorModal } = otpSlice.actions;
export default otpSlice.reducer;
